import(/* webpackMode: "eager" */ "/vercel/path0/app/affiliates/page.tsx");
